<div class="tk-select" [ngClass]="styleClass">

    <button [disabled]="disabled" #select__toggle class="select__header" [ngClass]="{'select__header--active': showList}"
        (click)="toggleShowList()" (blur)="onArrowBlur()">
        <div class="select__header-label">
            <ng-template 
                [ngTemplateOutlet]="itemTemplate"
                [ngTemplateOutletContext]="{ $implicit: optionValue }"
            ></ng-template>
        </div>
        <div class="select__toggle" [ngClass]="{'select__toggle--rotated': showList}">
            <div class="select__toggle__icon"></div>
        </div>
    </button>

    <div class="select__list" [ngClass]="{'select__list--visible': showList}">
        <div class="search-input" *ngIf="showSearchInput">
            <tk-search [themeType]="searchThemeEnum.Light" [control]="filterControl"
                (onEnterEvent)="onSearchEnter()" (onClearEvent)="onSearchClear()" (onFocusEvent)="onSearchFocus($event)"></tk-search>
        </div>
        <div class="select__list__items">
            <ng-container *ngFor="let item of filteredOptions">
                <div *ngIf="item != optionValue" class="select__item" (click)="selectItem(item)">
                    <ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{$implicit: item}">
                    </ng-template>
                </div>
            </ng-container>
        </div>
    </div>

</div>
